import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import * as global from '../global';
import {API_URL} from "../../../environments/api-url";
import { CommonService } from 'src/app/services/common.service';
import { AuthService } from 'src/app/services/auth.service';

@Injectable({
    providedIn: 'root',
})
export class PatientAddService {
    currentUser: any;
    company_id: any;
 
    constructor(private httpclient: HttpClient,
    private _authService:AuthService, 
        private commonService: CommonService,) {
            // this._authService.onUserAuthChange.subscribe(currentUser => {
            // });
            this.currentUser = this._authService.currentUser;
    }

    addNewPatient(patient) {
        this.commonService.castCompany.subscribe(company=>{
            this.company_id = company?._id
            // 
        })
        
        if(!this.company_id){
            this.company_id = this.currentUser.company_id
        }
        if(!patient.company_id)
            patient.company_id = this.company_id;
        
        console.log('add patient in service',patient);
        return this.httpclient
            .post(global.url + API_URL.PATIENT.addNewPatient, patient).pipe();
    }

    updatePatient(patient, checkAlreadyExists = true) {
        console.log('update patient in service 1',patient);

        this.commonService.castCompany.subscribe(company=>{
            this.company_id = company?._id
        })
        if(!this.company_id){
            this.company_id=this.currentUser.company_id
          }
          patient.company_id=this.company_id;

        patient = {
            ...patient,
            checkAlreadyExists
        }
        console.log('update patient in service',patient);
        return this.httpclient
            .post(global.url + API_URL.PATIENT.updatePatient, {patient}).pipe();
    }

    getFacilities(item) {

        this.commonService.castCompany.subscribe(company => {
            this.company_id = company?._id
          })
      
          if(!this.company_id){
            this.company_id=this.currentUser.company_id;
          }
          let address={
            ...item,
            company_id:this.company_id
          }
        return this.httpclient
            .post(global.url + API_URL.FACILITY.getMyAddress, {address: address }).pipe();
    }
    getAssociatedDoctorsList(item) {
        return this.httpclient
            .post(global.url + API_URL.USER.getAssociatedDoctorsListForMA, {details: item}).pipe();
    }
    getAssociatedDoctorsListforTrans(item) {
        return this.httpclient
            .post(global.url + API_URL.USER.getAssociatedDoctorsList, {details: item}).pipe();
    }
    getPatientInfoFromFaceSheet(data) {
        return this.httpclient
            .post(global.url + API_URL.PATIENT.getPatientInfoFromFaceSheet, data).pipe();
    }
    sendEmailToUsers(details){
        return this.httpclient
        .post(global.url + API_URL.PATIENT.sendEmailToUsers, details).pipe();
    }

    editPatient(filter, query, updatePatientsQuery = []){
        return this.httpclient.post(global.url + API_URL.PATIENT.editPatient, {filter: filter, query: query, updatePatientsQuery: updatePatientsQuery}).pipe();
    }
}
